module.exports = __webpack_public_path__ + "static/sherwin-williams-63c9337e2031ea925ba472494ca8547a.jpg";